import { CurrencyCode } from '@99designs/i18n';
import React from 'react';
import BriefSectionWrapper from '../../components/BriefSectionWrapper';
import ContentSetting from '../../components/ContentSetting';
import PaymentSummary from '../../components/PaymentSummary';
import { BriefStep } from '../../util/step';
import { Layout, MainContent, SideContent } from '../LogoDesign/Layout';
import { StructuredBriefFragment } from './DynamicBrief.generated';
import { Field, ObservableForm, ObservableFormContext } from '@99designs/brief';

export function createSteps(brief: StructuredBriefFragment, steps: BriefStep[]): BriefStep[] {
    return [
        ...brief.groups.map((group) => {
            const fields = brief.dynamicFields.filter((field) => field.groupId === group.id);

            return {
                title: group.title,
                fields: fields.map((field) => field.id),
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                render: (form: ObservableForm<any>) => (
                    <Step
                        form={form}
                        fields={fields}
                        brief={brief}
                        renderPaymentSummary={group.renderPaymentSummary}
                        fulfilmentMpvId={brief.product?.fulfilmentMpvId || ''}
                    />
                ),
            };
        }),
        ...steps,
    ];
}

interface Props {
    brief: StructuredBriefFragment;
    fields: React.ComponentProps<typeof Field.Edit>[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: ObservableForm<any>;
    renderPaymentSummary: boolean;
    fulfilmentMpvId?: string;
}

export function Step({ brief, fields, form, renderPaymentSummary, fulfilmentMpvId }: Props) {
    return (
        <ContentSetting>
            <Layout>
                <MainContent>
                    <ObservableFormContext.Provider value={{ form }}>
                        {fields.map((field) => {
                            return (
                                <Field.Edit
                                    key={field.id}
                                    {...field}
                                    uploader={brief.uploader}
                                    category={brief.category}
                                    currency={brief.currency as CurrencyCode}
                                    fulfilmentMpvId={fulfilmentMpvId}
                                />
                            );
                        })}
                    </ObservableFormContext.Provider>
                </MainContent>
                {renderPaymentSummary && (
                    <SideContent>
                        <BriefSectionWrapper>
                            <PaymentSummary
                                taxLabel={brief.gstApplicable ? 'GST' : __('Tax')}
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                {...brief.paymentSummary!}
                            />
                        </BriefSectionWrapper>
                    </SideContent>
                )}
            </Layout>
        </ContentSetting>
    );
}
